import request from "@/utils/request";

// login as admin, returns { token, username, role }
export const loginApi = (username, password) => {
    return request.post('/admin/login', {username, password})
}
